module.exports = __webpack_public_path__ + "static/media/BGalt.e27729f1.jpg";